import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import StickyCTA from "@/components/layout/StickyCTA";
import ExitIntent from "@/components/layout/ExitIntent";
import ScrollToTop from "@/components/layout/ScrollToTop";

import Home from "@/pages/Home";
import HotWaterHeatPumps from "@/pages/HotWaterHeatPumps";
import NeoPower from "@/pages/NeoPower";
import Calculator from "@/pages/Calculator";
import Installation from "@/pages/Installation";
import InstallerNetwork from "@/pages/InstallerNetwork";
import RecentInstalls from "@/pages/RecentInstalls";
import BecomeInstallerPartner from "@/pages/BecomeInstallerPartner";
import HomeShows from "@/pages/HomeShows";
import Finance from "@/pages/Finance";
import GreenLoanGuide from "@/pages/GreenLoanGuide";
import AeroMax270 from "@/pages/AeroMax270";
import SolarBattery from "@/pages/SolarBattery";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import FreeHomeAssessment from "@/pages/FreeHomeAssessment";
import Blog from "@/pages/Blog";
import Admin from "@/pages/Admin";
import Quiz from "@/pages/Quiz";
import Guide from "@/pages/Guide";
import Win from "@/pages/Win";
import ReviewRedirect from "@/pages/ReviewRedirect";

function App() {
  return (
    <div className="App bg-white text-[#0B132B] font-body">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />

            {/* Products */}
            <Route path="/hot-water-heat-pumps" element={<HotWaterHeatPumps />} />
            <Route path="/neopower-black-shield" element={<NeoPower />} />
            <Route path="/aeromax-270l" element={<AeroMax270 />} />
            <Route path="/solar-battery" element={<SolarBattery />} />

            {/* Calculator */}
            <Route path="/savings-calculator" element={<Calculator />} />

            {/* Installation */}
            <Route path="/installation" element={<Installation />} />
            <Route path="/installer-network" element={<InstallerNetwork />} />
            <Route path="/recent-installs" element={<RecentInstalls />} />
            <Route path="/become-installer-partner" element={<BecomeInstallerPartner />} />

            {/* Home Shows */}
            <Route path="/home-shows" element={<HomeShows />} />

            {/* Support */}
            <Route path="/nz-green-loan-guide" element={<GreenLoanGuide />} />
            <Route path="/finance" element={<Finance />} />{/* legacy */}
            <Route path="/contact" element={<Contact />} />
            <Route path="/free-home-assessment" element={<FreeHomeAssessment />} />
            <Route path="/faqs" element={<FAQ />} />
            <Route path="/faq" element={<FAQ />} />{/* legacy */}

            {/* Misc */}
            <Route path="/blog" element={<Blog />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/admin" element={<Admin />} />

            {/* Hidden campaign — Home Show QR giveaway. Not in nav/footer. */}
            <Route path="/win" element={<Win />} />

            {/* Redirect-only — /review → Google Review page. Not in nav/footer/sitemap. */}
            <Route path="/review" element={<ReviewRedirect />} />
          </Routes>
        </main>
        <Footer />
        <StickyCTA />
        <ExitIntent />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
